import { useMutation } from '@tanstack/react-query';
import { toast } from 'react-toastify';

import { sendEmail } from '../api';
import { forgotPassMutationKeys } from '../data';

export const useSendEmailMutation = () => {
  const mutation = useMutation({
    mutationKey: forgotPassMutationKeys.sendEmail,
    mutationFn: sendEmail,
    onSuccess: () => {
      toast.success('Reset link has been sent.');
    },
  });

  return mutation;
};
